import React from 'react';
import { ExternalLink } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t py-4 px-6">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-sm text-gray-600">
              &copy; {currentYear} Hypothecation Management System. All rights reserved.
            </p>
          </div>
          <div className="flex items-center">
            <p className="text-sm text-gray-600">
              Powered by 
              <a 
                href="https://www.vahanfin.com/channels/messaging/hypothecation" 
                className="text-blue-600 hover:text-blue-800 inline-flex items-center ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vahanfin Solutions Pvt Ltd
                <ExternalLink className="ml-1 h-3 w-3" />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
